
export default class attribute{
    constructor(id='', name, description, image, image_hover, position, field_type, value, childs){
        this.id = id;
        this.type_id = '';
        this.parent_id = '';
        this.position = 0;
        this.status = true;
        this.visibility = true;
        this.childs = childs;
        this.name = name;
        this.description = description;
        this.image = image;
        this.image_hover = image_hover;
        this.url = '';
        this.field_type = field_type;
        this.value = '';
    }
}
